import { render, staticRenderFns } from "./ClassUploadItem.vue?vue&type=template&id=6cb68386&scoped=true&"
import script from "./ClassUploadItem.vue?vue&type=script&lang=js&"
export * from "./ClassUploadItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassUploadItem.vue?vue&type=style&index=0&id=6cb68386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb68386",
  null
  
)

export default component.exports